




























































































import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class PrimaryFilter extends Vue {
  @Prop()
  private visible: any;
  @Prop()
  private filters: any;
  private f: any = {};
  private age: any = {
    自定义: false,
    开始年龄: "",
    结束年龄: ""
  };
  private laonianren: any = [
    "平和质",
    "气虚质",
    "阳虚质",
    "阴虚质",
    "痰湿质",
    "湿热质",
    "血瘀质",
    "气郁质",
    "特禀质"
  ];
  private ertong: any = [
    "健康体",
    "气虚体",
    "肝火体",
    "痰湿体",
    "怯弱体",
    "高敏体",
    "积滞体",
    "热盛体",
    "阳虚体"
  ];
  private tizhi: any = [
    "平和质",
    "气虚质",
    "阳虚质",
    "阴虚质",
    "痰湿质",
    "湿热质",
    "血瘀质",
    "气郁质",
    "特禀质"
  ];
  private sizhen: any = [
    "内寒质",
    "内热质",
    "平和质",
    "气虚质",
    "气郁质",
    "湿热质",
    "痰湿质",
    "特禀质",
    "血虚质",
    "血瘀质",
    "阳虚质",
    "阴虚质"
  ];
  private beiyun: any = [
    "阴血虚",
    "肝血虚",
    "心血虚",
    "脾肾阳虚",
    "肾气虚",
    "脾气虚",
    "健康体",
    "脾胃虚弱",
    "冲任虚损",
    "热",
    "心脾两虚",
    "肾阴虚",
    "血瘀",
    "气郁"
  ];
  private yunqi: any = [
    "脾胃虚弱",
    "心气虚",
    "痰湿",
    "痰热",
    "肝肾阴虚",
    "健康体",
    "阴虚血热",
    "肾气虚",
    "脾肾阳虚",
    "气滞",
    "津亏气弱"
  ];
  private chanhou: any = [
    "津亏气弱",
    "健康体",
    "肾气虚",
    "阴血虚",
    "气血两虚",
    "中气大虚",
    "肾精亏",
    "痰湿",
    "血瘀",
    "脾气虚",
    "心阴虚",
    "食积",
    "心气虚",
    "寒",
    "热",
    "气郁",
    "肾阴虚"
  ];
  private manxing: any = [
    "高血压病",
    "糖尿病",
    "冠心病",
    "高脂血病",
    "慢性支气管炎",
    "肿瘤",
    "易感人群"
  ];
  private time: any = {
    自定义: false,
    value: []
  };
  private get ifVisible() {
    return this.visible;
  }
  private set ifVisible(val) {
    this.$emit("update:visible", val);
  }
  /**
   * @description 确定
   */
  private save() {
    // 年龄段
    if (this.age["自定义"]) {
      this.f["年龄段"] = [this.age["开始年龄"] + "-" + this.age["结束年龄"]];
      this.f["自定义年龄"] = [true, this.age["开始年龄"], this.age["结束年龄"]];
    }
    // 时间段
    if (this.time["自定义"]) {
      this.f["时间段"] = this.time.value;
      this.f["自定义时间段"] = [true, this.time.value];
    }
    this.$emit("change", this.f);
  }
  /**
   * @description 初始化
   */
  private mounted() {
    for (const key in this.filters) {
      if (key) {
        this.$set(this.f, key, this.filters[key]);
      }
    }
    // 年龄段
    this.age["自定义"] = this.f["自定义年龄"][0];
    this.age["开始年龄"] = this.f["自定义年龄"][1];
    this.age["结束年龄"] = this.f["自定义年龄"][2];
    // 时间段
    this.time["自定义"] = this.f["自定义时间段"][0];
    this.time.value = this.f["自定义时间段"][1];
  }
}
